import { Machine } from '../../shared/types/machine';

/** Get standard label for a machine */
export const getMachineLabel = (m: Machine) => (
  `${m.internalNumber} - ${m.subCategoryName} - ${m.modelName}`
);
